import React, { useState } from 'react'
import { Panel, Row, Col, Form, SelectPicker } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ProjectInfoView from '../projectBasicInfo/ProjectInfoView'

export default function ManageProjectCoordinatorForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  return (
    <>
      {schema && (
        <Form fluid>
          <div>
            <Row style={{ marginTop: 30 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ErrorMessage
                  error={errors[schema.projectCoordinator.name]}
                  style={{ marginBottom: 10 }}
                />

                {requiredFiled(
                  schema.projectCoordinator.validators,
                  schema.projectCoordinator.label
                )}

                <Controller
                  name={schema.projectCoordinator.name}
                  control={control}
                  defaultValue={schema.projectCoordinator.value}
                  rules={isValidators(schema.projectCoordinator.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={schema.projectCoordinator.options}
                        //searchable={true}
                        disabled={schema.projectCoordinator.disabled}
                        value={props.value}
                        block
                        placeholder={
                          schema.projectCoordinator.hint ||
                          `เลือก${schema.projectCoordinator.label}`
                        }
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={schema.note}
                  rows={4}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </>
  )
}
